var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  z-index: 1000;\n  height: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  background-color: #fff;\n  position: fixed;\n  top: 0px;\n  width: 100%;\n  transition: background-color 0.3s ease-in-out;\n  border-bottom: 1px solid #eee;\n  @media (max-width: 700px) {\n    height: 50px;\n  }\n  @media print {\n    display: none;\n  }\n  &.open {\n    align-items: flex-start;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    position: fixed;\n    .client-desktop,\n    .client-mobile {\n      display: none;\n    }\n    .cta {\n      display: none;\n    }\n  }\n  .sidebar-wrapper {\n    transform: translateX(-320px);\n    transition: all 0.3s ease-in-out;\n    background-color: #fff;\n    div {\n      transition: all 0.3s ease-in-out;\n      transition-delay: 0.3s;\n      opacity: 0;\n    }\n  }\n  &.open {\n    .sidebar-wrapper {\n      z-index: 20;\n      left: 0;\n      transform: translateX(0px);\n      display: block;\n      position: fixed;\n      top: 0px;\n      height: 100%;\n      box-shadow: rgba(20, 20, 20, 0.1) 1px 1px 10px;\n      opacity: 1;\n      div {\n        opacity: 1;\n      }\n    }\n  }\n'], ['\n  z-index: 1000;\n  height: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  background-color: #fff;\n  position: fixed;\n  top: 0px;\n  width: 100%;\n  transition: background-color 0.3s ease-in-out;\n  border-bottom: 1px solid #eee;\n  @media (max-width: 700px) {\n    height: 50px;\n  }\n  @media print {\n    display: none;\n  }\n  &.open {\n    align-items: flex-start;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    position: fixed;\n    .client-desktop,\n    .client-mobile {\n      display: none;\n    }\n    .cta {\n      display: none;\n    }\n  }\n  .sidebar-wrapper {\n    transform: translateX(-320px);\n    transition: all 0.3s ease-in-out;\n    background-color: #fff;\n    div {\n      transition: all 0.3s ease-in-out;\n      transition-delay: 0.3s;\n      opacity: 0;\n    }\n  }\n  &.open {\n    .sidebar-wrapper {\n      z-index: 20;\n      left: 0;\n      transform: translateX(0px);\n      display: block;\n      position: fixed;\n      top: 0px;\n      height: 100%;\n      box-shadow: rgba(20, 20, 20, 0.1) 1px 1px 10px;\n      opacity: 1;\n      div {\n        opacity: 1;\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: #fff;\n'], ['\n  background-color: #fff;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  left: 0px;\n  position: fixed;\n  align-items: center;\n  height: 80px;\n  flex-direction: row;\n  justify-content: flex-start;\n  z-index: 21;\n  top: ', ';\n  @media (max-width: 700px) {\n    border-bottom: 1px solid ', ';\n    height: 50px;\n    width: 40%;\n    &.sidebar-open {\n      border: none;\n    }\n  }\n  @media (max-width: 320px) {\n    width: 45%;\n  }\n  &.has-no-border {\n    border: none;\n  }\n'], ['\n  display: flex;\n  left: 0px;\n  position: fixed;\n  align-items: center;\n  height: 80px;\n  flex-direction: row;\n  justify-content: flex-start;\n  z-index: 21;\n  top: ', ';\n  @media (max-width: 700px) {\n    border-bottom: 1px solid ', ';\n    height: 50px;\n    width: 40%;\n    &.sidebar-open {\n      border: none;\n    }\n  }\n  @media (max-width: 320px) {\n    width: 45%;\n  }\n  &.has-no-border {\n    border: none;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  position: fixed;\n  right: 0px;\n  top: ', ';\n  height: 80px;\n  width: 40%;\n  padding-right: 12px;\n\n  button:first-of-type {\n    @media (max-width: 950px) {\n      display: none;\n    }\n  }\n  button {\n  }\n  @media (max-width: 700px) {\n    border-left: 1px solid ', ';\n    border-bottom: 1px solid ', ';\n    height: 50px;\n    width: 60%;\n  }\n  @media (max-width: 320px) {\n    width: 55%;\n  }\n  &.has-no-border {\n    border: none;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  position: fixed;\n  right: 0px;\n  top: ', ';\n  height: 80px;\n  width: 40%;\n  padding-right: 12px;\n\n  button:first-of-type {\n    @media (max-width: 950px) {\n      display: none;\n    }\n  }\n  button {\n  }\n  @media (max-width: 700px) {\n    border-left: 1px solid ', ';\n    border-bottom: 1px solid ', ';\n    height: 50px;\n    width: 60%;\n  }\n  @media (max-width: 320px) {\n    width: 55%;\n  }\n  &.has-no-border {\n    border: none;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n'], ['\n  cursor: pointer;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-left: 12px;\n'], ['\n  margin-left: 12px;\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: flex-start;\n  a {\n    height: 50px;\n  }\n  &.client-desktop {\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n  &.client-mobile {\n    display: flex;\n    width: 100%;\n    padding-top: 2.85rem;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    span {\n      margin-bottom: 1rem;\n      color: ', ';\n    }\n    @media (min-width: 768px) {\n      display: none;\n    }\n  }\n  span {\n    margin-left: 12px;\n    margin-right: 12px;\n    color: ', ';\n    font-size: 14px;\n    font-weight: 400;\n    &.logo-text {\n      margin-top: 12px;\n    }\n    &.fineprint {\n      margin-top: 9px;\n      line-height: 16px;\n      color: ', ';\n      max-width: 170px;\n      font-size: 12px;\n\n      @media (max-width: 767px) {\n        margin-top: ', ';\n      }\n    }\n  }\n'], ['\n  display: flex;\n  align-items: flex-start;\n  a {\n    height: 50px;\n  }\n  &.client-desktop {\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n  &.client-mobile {\n    display: flex;\n    width: 100%;\n    padding-top: 2.85rem;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    span {\n      margin-bottom: 1rem;\n      color: ', ';\n    }\n    @media (min-width: 768px) {\n      display: none;\n    }\n  }\n  span {\n    margin-left: 12px;\n    margin-right: 12px;\n    color: ', ';\n    font-size: 14px;\n    font-weight: 400;\n    &.logo-text {\n      margin-top: 12px;\n    }\n    &.fineprint {\n      margin-top: 9px;\n      line-height: 16px;\n      color: ', ';\n      max-width: 170px;\n      font-size: 12px;\n\n      @media (max-width: 767px) {\n        margin-top: ', ';\n      }\n    }\n  }\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  height: ', ';\n'], ['\n  height: ', ';\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  @media (max-width: 768px) {\n    button {\n      display: none;\n      &.show-on-mobile {\n        display: block !important;\n      }\n      margin-bottom: 0px !important;\n      height: 38px;\n      padding-left: 1rem;\n      padding-right: 1rem;\n      font-size: 12px;\n    }\n  }\n  @media (max-width: 950px) {\n    button {\n      display: none;\n      &.show-on-mobile {\n        display: block !important;\n      }\n    }\n  }\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  &.prettify-list {\n    li {\n      list-style: none;\n    }\n  }\n'], ['\n  @media (max-width: 768px) {\n    button {\n      display: none;\n      &.show-on-mobile {\n        display: block !important;\n      }\n      margin-bottom: 0px !important;\n      height: 38px;\n      padding-left: 1rem;\n      padding-right: 1rem;\n      font-size: 12px;\n    }\n  }\n  @media (max-width: 950px) {\n    button {\n      display: none;\n      &.show-on-mobile {\n        display: block !important;\n      }\n    }\n  }\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  &.prettify-list {\n    li {\n      list-style: none;\n    }\n  }\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n  width: 270px;\n  margin-top: ', ';\n  padding: 1rem;\n  h6 {\n    margin-bottom: 0.5rem;\n    color: ', ';\n  }\n  ul {\n    list-style: none;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    padding-left: 0px;\n    margin-left: 0px;\n    li {\n      margin-top: 0.5rem;\n      margin-bottom: 0.5rem;\n      a {\n        color: ', ';\n        text-decoration: none;\n      }\n    }\n  }\n'], ['\n  width: 270px;\n  margin-top: ', ';\n  padding: 1rem;\n  h6 {\n    margin-bottom: 0.5rem;\n    color: ', ';\n  }\n  ul {\n    list-style: none;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    padding-left: 0px;\n    margin-left: 0px;\n    li {\n      margin-top: 0.5rem;\n      margin-bottom: 0.5rem;\n      a {\n        color: ', ';\n        text-decoration: none;\n      }\n    }\n  }\n']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n  margin-top: 0px !important;\n\n  a {\n    display: block;\n  }\n'], ['\n  margin-top: 0px !important;\n\n  a {\n    display: block;\n  }\n']),
    _templateObject12 = _taggedTemplateLiteralLoose(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject13 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 80px;\n  z-index: 999; /* Must appear beneath the menu and the modal pop up */\n  width: 100vw;\n  min-height: 40px;\n  color: ', ';\n  background-color: ', ';\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-box-align: center;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    color: ', ';\n  }\n\n  @media (max-width: 700px) {\n    top: 50px;\n  }\n'], ['\n  position: fixed;\n  top: 80px;\n  z-index: 999; /* Must appear beneath the menu and the modal pop up */\n  width: 100vw;\n  min-height: 40px;\n  color: ', ';\n  background-color: ', ';\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-box-align: center;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    color: ', ';\n  }\n\n  @media (max-width: 700px) {\n    top: 50px;\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import { isNil, isEmpty, pipe, not } from 'ramda';
import styled from 'styled-components';
import { withTheme } from 'styled-components';
import Burger from '../Burger';
import Banner from '../Banner';
import Logo from '../Logo';
import { generateMenuItems } from './config';
import { wrapDomain, wrapAncor, wrapAssetPath, appendQuery } from '../../../utils';
import PricingOverlay, { isBlackListedRoute } from '../PricingOverlay';
import { Header as Astro3Header, Theme as Astro3Theme } from '@simply-fin-services/astronomix3';
import OM_Header from "../../Partners/OM/Header";
import ABSA_Header from "../../Partners/ABSA/Header";
import RML_Header from "../../Partners/RML/Header";
var Nav = styled.nav(_templateObject, function (props) {
  return props.showBanner ? '128px' : '80px';
});
var MenuWrapper = styled.div(_templateObject2);
var LeftMenu = styled.div(_templateObject3, function (props) {
  return props.showBanner ? '48px' : '0px';
}, function (props) {
  return props.theme.colours.neutral.lighter;
});
var RightMenu = styled.div(_templateObject4, function (props) {
  return props.showBanner ? '48px' : '0px';
}, function (props) {
  return props.theme.colours.neutral.lighter;
}, function (props) {
  return props.theme.colours.neutral.lighter;
});
var BurgerWrapper = styled.div(_templateObject5);
var ButtonContainer = styled.div(_templateObject6);
var Client = styled.div(_templateObject7, function (props) {
  return props.theme.colours.neutral.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.spaces.tight;
});
var ClientLogo = styled.img(_templateObject8, function (props) {
  return props.height;
});
var Buttons = styled.div(_templateObject9);
var Sidebar = styled.div(_templateObject10, function (props) {
  return props.showBanner ? '6rem' : '3rem';
}, function (props) {
  return props.theme.colours.neutral.darkest;
}, function (props) {
  return props.theme.colours.primary.base;
});
var LinkList = styled.ul(_templateObject11);
var LogoContainer = styled.a(_templateObject12);
var Ribbon = styled.div(_templateObject13, function (props) {
  return props.theme.colours.primary.lightest;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.light_text;
});
export var SidebarLinks = function SidebarLinks(props) {
  var linkGroups = props.linkGroups;
  return React.createElement('div', {
    className: 'sidebar-links'
  }, (linkGroups || []).map(function (linkGroup, index) {
    var groupKey = linkGroup.title + '_' + index;
    return React.createElement(React.Fragment, {
      key: groupKey
    }, linkGroup.title && React.createElement('h4', {
      className: 'no-margins'
    }, linkGroup.title), React.createElement(LinkList, null, linkGroup.links.map(function (link, i) {
      return React.createElement(React.Fragment, {
        key: groupKey + '_' + i
      }, link);
    })));
  }));
};

var themeLogoPath = function themeLogoPath(props) {
  var theme = props.theme,
      logoPathPrefix = props.logoPathPrefix;

  var path = require('../../../themes/logos/' + theme.logo);

  return logoPathPrefix ? '' + logoPathPrefix + path : path;
};

var getTypeOfSimplyTheme = function getTypeOfSimplyTheme(isDark) {
  return isDark === true ? 'simplydark' : 'simplylight';
};
/*
Proposed anatomy of the header:
- Logo with "logoDomain" falls back to "websiteDomain" falls back to DEFAULT WEBSITE URL.

- There are two navigational components.
  - Horizontal: buttons/links displayed next to a login button.
    Defaults to Get a quote | FAQs | Call me back pointing to DEFAULT WEBSITE.

  - Vertical: a "sidebar" with "linkGroups" which builds a vertical menu
    which is ideally displayed in the form of a hamburger and menu that
    flies out from the side or top of the page.
    There is no default. If nothing is supplied, the vertical bar
    button should not show. TODO: merge with "rightMenu".

- Login / Logout button
  Users should be able to log in to group (employers) or admin (employees).
  The group and admin base URLs will be used to create these login links.
  The "isLoggedIn" flag will determine which button to display.
  If the "logoutUrl" is not supplied then the logout button must not show.
  There may be cases where the login button shouldn't show at all.
  With the employer/employee context, panoramix shouldn't display the login button
  defined in the header but rather a link on the menu.

- Ribbon
  This baby is used to show additional information on the header which primarily
  is used for Panoramix (Advisor/Broker Portal) to allow users to go back to the
  portal from the retail and group quoting apps.

  Dangerously, any strip of html is to be catered for. Which is probably a bad idea but necessary
  for the mixture of text and links in an arbitrary order.
*/


var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var defaultBannerVisibility = false;

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      open: false,
      bannerVisible: defaultBannerVisibility
    };
    _this.toggleBurger = _this.toggleBurger.bind(_this);
    _this.toggleBanner = _this.toggleBanner.bind(_this);
    return _this;
  }

  Header.prototype.toggleBurger = function toggleBurger() {
    this.setState({
      open: !this.state.open
    });
  };

  Header.prototype.toggleBanner = function toggleBanner() {
    if (this.state.bannerVisible === true) {
      this.setState({
        bannerVisible: false
      });
    }
  };

  Header.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        logoDomain = _props.logoDomain,
        buttons = _props.buttons,
        pricingOverlayConfig = _props.pricingOverlayConfig,
        bannerUID = _props.bannerUID,
        linksDomain = _props.linksDomain,
        ribbon = _props.ribbon,
        login = _props.login,
        logout = _props.logout,
        isLoggedIn = _props.isLoggedIn,
        isDark = _props.isDark,
        pilltext = _props.pilltext,
        statuslink = _props.statuslink,
        statustext = _props.statustext,
        openLiveChat = _props.openLiveChat,
        callMeLink = _props.callMeLink,
        calculatorLink = _props.calculatorLink,
        rightMenu = _props.rightMenu,
        breadcrumb = _props.breadcrumb,
        hideQuoteButtons = _props.hideQuoteButtons,
        quoteButtonsConfig = _props.quoteButtonsConfig,
        removeTopBar = _props.removeTopBar,
        ribbonStyle = _props.ribbonStyle,
        linkGroups = _props.linkGroups; // TODO: Defaq is this?! o_O The condition below matching the om theme does not use this prop

    var noLogo = ['oldmutual'];
    var hasSidebar = not(isNil(linkGroups) || isEmpty(linkGroups));

    var _ref = !isNil(pricingOverlayConfig) ? pricingOverlayConfig : {
      currentPage: '',
      blacklistedRoutes: []
    },
        currentPage = _ref.currentPage,
        blacklistedRoutes = _ref.blacklistedRoutes;

    var showsPricingOverlay = !isNil(pricingOverlayConfig) && !isEmpty(pricingOverlayConfig);
    var currentRouteIsBlacklisted = showsPricingOverlay ? isBlackListedRoute(currentPage, blacklistedRoutes) : false;
    var borderClass = !showsPricingOverlay || currentRouteIsBlacklisted ? 'has-no-border' : '';
    var sidebarLinks = linkGroups && linkGroups.length > 0 ? React.createElement(SidebarLinks, {
      linkGroups: linkGroups
    }) : null;

    if (theme.name === 'oldmutual') {
      return React.createElement(OM_Header, _extends({}, this.props, {
        sidebar: sidebarLinks,
        isLoggedIn: isLoggedIn,
        loginUrl: login && login.url ? login.url : null,
        logoutUrl: logout && logout.url ? logout.url : null,
        ribbon: ribbon
      }));
    } else if (theme.name === "absa") {
      return (// Don't pass props in to header. There be dragons o_O
        React.createElement(ABSA_Header, null)
      );
    } else if (theme.name === "rml") {
      return React.createElement(RML_Header, _extends({}, this.props, {
        sidebar: sidebarLinks
      }));
    } else if (theme.name === "simply") {
      var themeName = getTypeOfSimplyTheme(isDark);
      return React.createElement(Astro3Theme, {
        themeName: themeName,
        hideHeader: true
      }, React.createElement(Astro3Header, {
        pilltext: pilltext,
        statuslink: statuslink,
        statustext: statustext,
        openLiveChat: openLiveChat,
        callMeLink: callMeLink,
        calculatorLink: calculatorLink,
        login: login,
        logout: logout,
        rightMenu: rightMenu,
        hideQuoteButtons: hideQuoteButtons,
        pricingOverlayConfig: pricingOverlayConfig,
        breadcrumb: breadcrumb,
        ribbon: ribbon,
        burgerMenu: linkGroups || [],
        removeTopBar: removeTopBar,
        isLoggedIn: isLoggedIn,
        logoDomain: logoDomain,
        quoteButtonsConfig: quoteButtonsConfig,
        linksDomain: linksDomain,
        ribbonStyle: ribbonStyle
      }));
    } else {
      return React.createElement(React.Fragment, null, this.state.bannerVisible !== false && React.createElement(Banner, {
        uid: bannerUID,
        backgroundColor: this.props.bannerColour,
        toggle: this.toggleBanner
      }, this.props.banner), React.createElement(Nav, {
        className: this.state.open ? 'open' : '',
        showBanner: this.state.bannerVisible
      }, hasSidebar && React.createElement('div', {
        className: 'sidebar-wrapper'
      }, React.createElement(Sidebar, {
        showBanner: this.state.bannerVisible
      }, sidebarLinks)), React.createElement(MenuWrapper, null, React.createElement(LeftMenu, {
        className: this.state.open ? borderClass + ' sidebar-open' : borderClass,
        showBanner: this.state.bannerVisible
      }, hasSidebar && React.createElement(BurgerWrapper, {
        onClick: this.toggleBurger
      }, React.createElement(Burger, {
        open: this.state.open
      })), !hasSidebar && React.createElement('span', {
        className: 'indent'
      }), noLogo.indexOf(theme.name) == -1 && React.createElement('div', null, React.createElement(LogoContainer, {
        href: logoDomain
      }, React.createElement(Logo, {
        height: '47px',
        width: '146px'
      }))), theme.logo && React.createElement(Client, {
        className: 'client-desktop'
      }, theme.logo_text && React.createElement('span', {
        className: 'logo-text'
      }, theme.logo_text), React.createElement('a', {
        rel: 'noopener',
        target: '_blank',
        href: theme.logo_link
      }, React.createElement(ClientLogo, {
        height: '50px',
        src: wrapAssetPath(this.props.theme, themeLogoPath(this.props))
      })), React.createElement('span', {
        className: 'fineprint'
      }, theme.logo_fineprint))), React.createElement(RightMenu, {
        className: borderClass + ' cta',
        showBanner: this.state.bannerVisible
      }, showsPricingOverlay && React.createElement(PricingOverlay, {
        config: pricingOverlayConfig
      }), not(isNil(buttons)) && React.createElement(Buttons, {
        className: 'thesearethebuttons prettify-list'
      }, React.createElement(Fragment, null, buttons.map(function (btn, index) {
        return React.createElement(ButtonContainer, {
          key: index
        }, btn);
      })))))), theme.logo && React.createElement(Client, {
        className: 'client-mobile'
      }, React.createElement('span', null, theme.logo_text), React.createElement('a', {
        rel: 'noopener',
        target: '_blank',
        href: theme.logo_link
      }, React.createElement(ClientLogo, {
        height: '50px',
        src: themeLogoPath(this.props)
      })), React.createElement('span', {
        className: 'fineprint text-center'
      }, theme.logo_fineprint)), ribbon && React.createElement(Ribbon, null, ribbon));
    }
  };

  return Header;
}(Component);

var DefaultHeaderC = function (_Component2) {
  _inherits(DefaultHeaderC, _Component2);

  function DefaultHeaderC() {
    _classCallCheck(this, DefaultHeaderC);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  DefaultHeaderC.prototype.render = function render() {
    var _props2 = this.props,
        linksDomain = _props2.linksDomain,
        queryString = _props2.queryString,
        linkGroups = _props2.linkGroups;
    var linkF = pipe(wrapDomain(linksDomain), appendQuery(queryString), wrapAncor);
    var groups = this.props.theme.isSimplyBased ? generateMenuItems(linkF) : linkGroups;
    return React.createElement(Header, _extends({}, this.props, {
      linkGroups: groups
    }));
  };

  return DefaultHeaderC;
}(Component);

export default withTheme(Header);
export var DefaultHeader = withTheme(DefaultHeaderC);